var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.75 5.25002V16.5C21.7494 16.6068 21.726 16.7122 21.6814 16.8092C21.6368 16.9062 21.5719 16.9926 21.4913 17.0625C20.0588 18.3028 18.6891 18.75 17.3831 18.75C15.6103 18.75 13.9547 17.9306 12.4144 17.1703C9.92531 15.9375 7.76156 14.8697 5.25 16.8535V21C5.25 21.1989 5.17098 21.3897 5.03033 21.5303C4.88968 21.671 4.69891 21.75 4.5 21.75C4.30109 21.75 4.11032 21.671 3.96967 21.5303C3.82902 21.3897 3.75 21.1989 3.75 21V5.25002C3.75072 5.14317 3.77426 5.03771 3.81905 4.9407C3.86383 4.84369 3.92883 4.75737 4.00969 4.68752C7.38469 1.76439 10.4137 3.26158 13.0837 4.58252C15.6562 5.85564 17.8866 6.95627 20.5087 4.68752C20.6171 4.59357 20.7502 4.53267 20.8921 4.51203C21.0341 4.4914 21.1789 4.5119 21.3096 4.5711C21.4402 4.63031 21.5512 4.72573 21.6292 4.84606C21.7073 4.9664 21.7492 5.10659 21.75 5.25002Z",
    fill: "#141B8E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/Flag.db123a41307030c1938a60f6d2a7ba31.svg";
export { ForwardRef as ReactComponent };